import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model"

export class CreateIndiceAjusteContratoRequest extends CreateKeyValueRequest{
  public valor!: number
  public fecha!: string
  public activo!: boolean
  public idTipoAjusteContrato!: number
}

